import React, { Suspense, lazy, useState } from 'react';
import HeroSection from '../components/HeroSection';
import StickyFooter from '../components/StickyFooter';
import StickyCTAs from '../components/StickyCTAs';

// Everything below the hero ships as its own chunk and mounts after the hero
// has painted — the form is the only thing a visitor needs immediately, and
// parsing the whole page's JS before showing it is what made the first render
// feel slow.
const TestDetails = lazy(() => import('../components/TestDetails'));
const MostBookedPackages = lazy(() => import('../components/MostBookedPackages'));
const WhyBookWithUs = lazy(() => import('../components/WhyBookWithUs'));
const TestimonialsSection = lazy(() => import('../components/TestimonialsSection'));
const CantFindSection = lazy(() => import('../components/CantFindSection'));
const FAQSection = lazy(() => import('../components/FAQSection'));
const Footer = lazy(() => import('../components/Footer'));

// Reserves vertical space so the sticky CTAs and scroll position don't jump
// as each chunk lands.
const SectionPlaceholder = () => <div className="min-h-[320px]" aria-hidden="true" />;

const DefaultTemplate = () => {
    const [selectedPackage, setSelectedPackage] = useState(null);

    // Receives the full package object (title, catalogId, itemType) from
    // MostBookedPackages' "Book Now" click — HeroSection uses catalogId/
    // itemType to build the cart, not just the title, so a specific package
    // card's selection actually reaches the booking-portal cart.
    const handlePackageSelect = (pkg) => {
        setSelectedPackage(pkg);
    };

    return (
        <div className="min-h-screen bg-white overflow-x-hidden">
            <HeroSection selectedPackage={selectedPackage} />

            <Suspense fallback={<SectionPlaceholder />}>
                <TestDetails />
                <MostBookedPackages onPackageSelect={handlePackageSelect} />

                {/* Why Book With Us (Includes Blue CTA Banner) */}
                <WhyBookWithUs />

                {/* Reviews Section */}
                <TestimonialsSection />

                {/* Can't Find / Help Section */}
                <CantFindSection />

                {/* FAQ Section */}
                <FAQSection />

                {/* Footer only - removed all other sections */}
                <Footer />
            </Suspense>

            <StickyFooter />
            <StickyCTAs />
        </div>
    );
};

export default DefaultTemplate;
